module.exports = __webpack_public_path__ + "static/media/insta.38825c9d.png";